import './WipPill.css';

function WipPill() {
  return <span className="wip-pill">WIP</span>;
}

export default WipPill;
